import { graphql } from '@/generated/gql';

export const NEWSROOM_WIDGET_QUERY = graphql(/* GraphQL */ `
  query NewsroomWidget($id: ID!, $offset: Int, $limit: Int, $locale: String) {
    supplier(id: $id) {
      id
      news(limit: $limit, offset: $offset, locale: $locale) {
        nodes {
          id
          title
          date
          url
          source {
            title
            url
          }
        }
        totalCount
      }
    }
  }
`);
